import { render, staticRenderFns } from "./DetailEditEmas.vue?vue&type=template&id=acdff0ba&scoped=true&"
import script from "./DetailEditEmas.vue?vue&type=script&lang=js&"
export * from "./DetailEditEmas.vue?vue&type=script&lang=js&"
import style0 from "./DetailEditEmas.vue?vue&type=style&index=0&id=acdff0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdff0ba",
  null
  
)

export default component.exports